import { createSelector } from "reselect"
import { get } from "lodash"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeResourcePermissionsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"
import { getFullResourceType } from "modules/resources/helpers"

const EMPTY_ARRAY = []

export const getResourceType = (_, props) => getFullResourceType(props.params.resourceType)
export const getResourceId = (_, props) => get(props, "resourceTokens.resource.id")
export const getResourcePermissionLevel = (_, props) => get(props, "resourceTokens.resource.permissionLevel")
export const getAccountTokens = (_, props) => get(props, "accountTokens.tokens", EMPTY_ARRAY)
export const getResourceTokens = (_, props) => get(props, "resourceTokens.resource.tokens", EMPTY_ARRAY)

export const getTabs = createSelector(
  [getRoute, getPath, getResourceType, getIsOpPro],
  computeResourcePermissionsTabs,
)
